import { NimmstaLayout } from './NimmstaLayout';
const LAYOUT = `<?xml version="1.0" encoding="utf-8"?>
<NimmstaLayout name="Two Cell Layout with Headers">
    <device width="1.54" height="1.54" pxx="200" pxy="200">
        <screen default="true" name="default">
            <staticElements>
                <statusbar />
                <cell x="3" horizontalAlignment="left" fontSize="11pt" name="header1"></cell>
                <cell x="3" horizontalAlignment="left" fontSize="auto" name="text1"></cell>
                <horizontalLine y="110"></horizontalLine>
                <cell x="3" horizontalAlignment="left" fontSize="11pt" name="header2"></cell>
                <cell x="3" horizontalAlignment="left" fontSize="auto" wrapMode="wrap" maxLines="0" name="text2"></cell>
            </staticElements>
        </screen>
    </device>
</NimmstaLayout>`;
export class TwoCellHeaderLayout extends NimmstaLayout {
    constructor(header1, text1, header2, text2) {
        super(LAYOUT, {
            header1, text1, header2, text2,
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHdvQ2VsbEhlYWRlckxheW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2xheW91dHMvVHdvQ2VsbEhlYWRlckxheW91dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFFaEQsTUFBTSxNQUFNLEdBQUc7Ozs7Ozs7Ozs7Ozs7O2lCQWNFLENBQUM7QUFLbEIsTUFBTSxPQUFPLG1CQUFvQixTQUFRLGFBQWE7SUFDcEQsWUFBWSxPQUFlLEVBQUUsS0FBYSxFQUFFLE9BQWUsRUFBRSxLQUFhO1FBQ3hFLEtBQUssQ0FBQyxNQUFNLEVBQUU7WUFDWixPQUFPLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRSxLQUFLO1NBQy9CLENBQUMsQ0FBQztJQUNMLENBQUM7Q0FDRiJ9